import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

import MyProfile from './my-profile';
import TwoFactorAuthSetup from './two-factor-auth-setup';

export default function MyAccountTab() {
  return (
    <Box>
      <MyProfile />
      <Divider sx={{ my: 4 }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}>
        <Typography
          variant="h6"
          sx={{ mb: 2, textAlign: 'center' }}>
          Two-factor authentication
        </Typography>
        <TwoFactorAuthSetup />
      </Box>
    </Box>
  );
}
